<template>
  <div class="flex-1 flex items-center justify-center bg-gradient-to-br from-gray-50 to-blue-50">
    <div class="text-center px-8">
      <div class="mx-auto w-32 h-32 bg-gradient-to-br from-blue-100 to-indigo-200 rounded-full flex items-center justify-center mb-8 shadow-lg">
        <svg class="w-16 h-16 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      </div>
      <h3 class="text-2xl font-semibold text-gray-900 mb-4">Start a Conversation</h3>
      <p class="text-gray-600 text-lg max-w-md leading-relaxed">
        Select a tutor from the list to view your conversation history and send new messages.
      </p>
      <div class="mt-8 flex items-center justify-center space-x-2 text-sm text-gray-500">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>Your messages will appear here once you start chatting</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyChat'
}
</script>
